
import React, { useState } from "react";

// third-party imports
import { Modal, Form } from "react-bootstrap";

// project imports
import { useInterviewContext } from "../../context/interview_context";
import reasonList from "../../data/feedback/reasonList.json";
import Spinner from "../spinner-component/SpinnerOne";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";

const FeedbackModal = ({
    show,
    setShow,
    onCloseModal,
    seriesId,
    currentUserId
}) => {

    // Extracting methods and variables form the context
    const { sendUSerFeedback, isSeriesFeedbackLoading, isSeriesFeedbackError } = useInterviewContext();

    const initialState = {
        reason: "",
        content: "",
    }
    // State Intialization
    const [feedback, setFeedback] = useState(initialState);
    const [errors, setErrors] = useState(initialState);

    // Handle reason selection
    const handleReasonChange = (e) => {
        try {
            const value = e.target.value;

            setFeedback((prev) => ({
                ...prev,
                reason: value,
            }));

            // Clear reason error
            setErrors((prev) => ({
                ...prev,
                reason: "",
            }));
        } catch (error) {
            console.log("47: FeedbackModal : Error in handleReasonChange", error);
        }
    };

    // Handle textarea
    const handleMessageChange = (e) => {
        try {
            const value = e.target.value;

            setFeedback((prev) => ({
                ...prev,
                content: value,
            }));

            // Clear message error
            setErrors((prev) => ({
                ...prev,
                content: "",
            }));
        } catch (error) {
            console.log("67 : FeedbackModal : Error in handleMessageChange", error);
        }
    };

    // Submit feedback
    const handleSubmitFeedback = async (e) => {
        e.preventDefault();
        try {
            const newErrors = {
                reason: "",
                content: "",
            };
            const body = { ...feedback, seriesId: seriesId, userId: currentUserId }

            // Validate reason
            if (!feedback.reason?.trim()) {
                newErrors.reason = "Please select a reason.";
            }

            // Validate content
            if (!feedback.content?.trim()) {
                newErrors.content = "Let us Know your review.";
            }

            // Set validation errors
            setErrors(newErrors);

            // Stop submission if validation fails
            if (newErrors.reason || newErrors.content) {
                return;
            }

            sendUSerFeedback(seriesId, body);

            if (isSeriesFeedbackError) {
                setShow(show)
            }
            else {
                onCloseModal();
            }

            // Reset form after successful submission
            setFeedback({
                reason: "",
                content: "",
            });

            setErrors({
                reason: "",
                content: "",
            });
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.FEEDBACK_INTERVIEW_SERIES
            )
        } catch (error) {
            console.error("106 : FeedbackModal : Error in handleSubmitFeedback", error);
        }
    };

    return (
        <div>
            {isSeriesFeedbackLoading && <Spinner />}
            <Modal
                className="rounded-lg"
                show={show}
                onHide={onCloseModal}
                size="lg"
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header
                    closeButton
                    className="px-4 border-bottom-1"
                >
                    <Modal.Title
                        as="h5"
                        className="my-2"
                    >
                        Help Us Make Our Q&A Series Better
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-4 p-0">

                    {/* Reason */}
                    <div className="radio-group my-4">
                        {(reasonList || [])?.map((reason) => {
                            const isSelected =
                                feedback?.reason === reason?.value;

                            return (
                                <div key={reason?.value}>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="abuseReason"
                                        id={reason?.value}
                                        value={reason?.value}
                                        checked={isSelected}
                                        onChange={handleReasonChange}
                                    />

                                    <label
                                        className={`radio-card ${isSelected ? "selected" : ""
                                            }`}
                                        htmlFor={reason?.value}
                                    >
                                        <span className="">{reason?.label}</span>

                                        {isSelected && (
                                            <span className="check-icon">
                                                ✓
                                            </span>
                                        )}
                                    </label>
                                </div>
                            );
                        })}

                        {/* Reason Error */}
                        {errors?.reason && (
                            <div className="text-danger mt-2">
                                {errors?.reason}
                            </div>
                        )}
                    </div>

                    {/* Feedback */}
                    <Form>
                        <Form.Group
                            className="my-3"
                            controlId="feedbackMessage"
                        >
                            <label
                                className="mb-0 fs-20 fw-semibold"
                            >
                                What did you think?
                            </label>

                            <p className="mb-3">
                                Tell us what you enjoyed, what helped you
                                learn, or what we could improve. Every bit of
                                feedback helps!
                            </p>

                            <textarea
                                as="form-control"
                                rows={5}
                                placeholder="Write your feedback here..."
                                value={feedback?.content}
                                onChange={handleMessageChange}
                                required
                                isInvalid={!!errors?.content}
                                className="fs-3"
                            />

                            {/* Message Error */}
                            {errors?.content && (
                                <div className="text-danger mt-2">
                                    {errors?.content}
                                </div>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="px-4 justify-content-start mb-2">
                    <button
                        type="button"
                        className="edu-btn btn-primary btn-medium mx-1"
                        onClick={handleSubmitFeedback}
                    >
                        Submit
                    </button>

                    <button
                        type="button"
                        className="edu-btn btn-border-gray btn-medium mx-1"
                        onClick={onCloseModal}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default FeedbackModal;